import React, { PropTypes } from 'react'
import { Relayout, RelayoutItem } from 'relayout'
import CSSModules from 'react-css-modules'
import { Link } from 'react-router'

import ValueLabel from 'components/value-label'
import { formatPriceDecimals } from 'utils/format'

import styles from './performance-list-item.css'

import ArrowRight from '../../../assets/icons/arrow-right.svg'

const PerformanceListItem = ({
  currencyCode,
  soldTickets,
  ticketCount,
  time,
  totalPartnerShare,
  type,
  url,
}) => (
  <Link styleName="performance-list-item" to={url}>
    <Relayout valign="middle">
      <RelayoutItem sm="6">
        <div styleName="time">
          <ValueLabel label={type} size="small" value={time} />
        </div>
      </RelayoutItem>
      <RelayoutItem sm="3">
        <span styleName="meta">{soldTickets} / {ticketCount}</span>
      </RelayoutItem>
      <RelayoutItem sm="3">
        <span styleName="meta">{formatPriceDecimals(totalPartnerShare, currencyCode)}</span>
      </RelayoutItem>
    </Relayout>
    <ArrowRight styleName="arrow" />
  </Link>
)

PerformanceListItem.propTypes = {
  currencyCode: PropTypes.string,
  soldTickets: PropTypes.any,
  ticketCount: PropTypes.any,
  time: PropTypes.any,
  totalPartnerShare: PropTypes.any,
  type: PropTypes.any,
  url: PropTypes.string,
}

export default CSSModules(PerformanceListItem, styles, { allowMultiple: true })



/** WEBPACK FOOTER **
 ** ./src/components/performance-list-item/performance-list-item.js
 **/